// Crave-owned launch fixtures for the public landing animation.
//
// Do not put Google Places photo refs, Google ratings, Google summaries, or
// catalogue rows with unresolved rights in this file. The real app can fetch
// live Google display-time details after launch; this public marketing surface
// should stay independent of Maps Platform content storage.

/** @type {Array<{id:number,name:string,cuisine:string,neighborhood:string,price:string|null,rating:number|null,photo:string|null,summary:string|null}>} */
export const venues = [
  {
    id: 1,
    name: 'The Basil Room',
    cuisine: 'Italian',
    neighborhood: 'Short North',
    price: '$$',
    rating: null,
    photo: null,
    summary: null,
  },
  {
    id: 2,
    name: 'June & Salt',
    cuisine: 'Seafood',
    neighborhood: 'Downtown',
    price: '$$$',
    rating: null,
    photo: null,
    summary: null,
  },
  {
    id: 3,
    name: 'Market Noodle',
    cuisine: 'Ramen',
    neighborhood: 'Arena District',
    price: '$$',
    rating: null,
    photo: null,
    summary: null,
  },
  {
    id: 4,
    name: 'Good Table',
    cuisine: 'American',
    neighborhood: 'German Village',
    price: '$$',
    rating: null,
    photo: null,
    summary: null,
  },
  {
    id: 5,
    name: 'Citrus House',
    cuisine: 'Mexican',
    neighborhood: 'Brewery District',
    price: '$',
    rating: null,
    photo: null,
    summary: null,
  },
];
